<template>
	<el-col :span="24" />
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	name: 'DmsColClear',
});
</script>
